import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7aa289a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "syser" }
const _hoisted_2 = { class: "syser-tab" }
const _hoisted_3 = {
  key: 0,
  class: "syser-bottom"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.$t('me.setting'),
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.onItemClick('返回')))
    }, null, 8 /* PROPS */, ["title"]),
    _createCommentVNode(" <div class=\"syser-tab\">\r\n      <van-cell title=\"关于我们\" @click=\"onItemClick('关于我们')\" is-link />\r\n      <van-cell title=\"检查更新\" @click=\"onItemClick('检查更新')\" is-link :value=\"'v' + version \" />\r\n    </div> "),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_cell, {
        title: $setup.t('me.setPass'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onItemClick('密码'))),
        "is-link": "",
        value: $setup.user.fname && $setup.user.fname != '' ? $setup.t('me.yset') : $setup.t('me.nosetting')
      }, null, 8 /* PROPS */, ["title", "value"]),
      _createVNode(_component_van_cell, {
        title: $setup.t('设置邮箱'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onItemClick('邮箱'))),
        "is-link": "",
        value: $setup.user.email && $setup.user.email != '' ? $setup.t('me.yset') : $setup.t('me.nosetting')
      }, null, 8 /* PROPS */, ["title", "value"])
    ]),
    (!$setup.isYk)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_van_button, {
            type: "primary",
            color: "#F0082E",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.onItemClick('退出'))),
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('me.out')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}